import Flickity from "flickity";

export default () => {

    const sliders = document.querySelectorAll('[data-testimonial-slider]');
    if (sliders.length) {
        for (const slider of sliders) {
            const flickity = new Flickity(slider, {
                // options
                contain: true,
                prevNextButtons: false,
                pageDots: true,
            });
        }
    }

}
